import React from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import LoginComponent from "./Componentes/Login/Login.component";
import RecuperarComponent from "./Componentes/Recuperar/Recuperar.component";
import ModalMensajeComponent from "./../../Shared/Componentes/ModalMensaje/ModalMensaje.component";
import LoaderPortal from "./../../Portales/Loader/Loader.portal";
import * as loginActions from "./../../Core/Actions/Login.actions";
import "./Login.page.scss";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Modal: {
        Mostrar: false,
        Mensaje: "",
      },
      MostrarRecuperar: false,
    };
  }

  componentDidMount() {
    this.setState({
      Modal: {
        Mostrar: false,
        Mensaje: "",
      },
      MostrarRecuperar: false,
    });
  }

  handleClickLogin = async (usuario, clave) => {
    const { consumirLogin } = this.props;

    if (usuario === "") {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: "Discúlpe, debe ingresar el usuario.",
        },
      });
      return;
    }

    if (clave === "") {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: "Discúlpe, debe ingresar la clave.",
        },
      });
      return;
    }

    await consumirLogin(usuario, clave);

    if (this.props.loginReducer.Resultado !== "S") {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: this.props.loginReducer.Mensaje,
        },
      });
      return;
    }
  };

  handleClickGoogle = async () => {
    await this.props.consumirLoginClienteGoogle();
    if (this.props.loginReducer.Resultado !== "S") {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: this.props.loginReducer.Mensaje,
        },
      });
      return;
    }
  };

  handleMostrarModal = () => {
    this.setState({
      Modal: {
        Mostrar: !this.state.Modal.Mostrar,
        Mensaje: "",
      },
    });
  };

  handleMostrarRecuperar = (mostrar) => {
    this.setState({
      MostrarRecuperar: mostrar,
    });
  };

  handleRecuperarPass = async (correo) => {
    const { consumirCambioClave } = this.props;

    if (correo === "") {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: "Discúlpe, debe ingresar el correo.",
        },
      });
      return;
    }

    await consumirCambioClave(correo);
    const { Resultado, Mensaje } = this.props.loginReducer;

    if (Resultado !== "S") {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: Mensaje,
        },
      });
      return;
    } else {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: "Revise su correo para cambiar la contraseña",
        },
      });
      this.handleMostrarRecuperar(false);
    }
  };

  render() {
    return (
      <>
        <LoaderPortal />
        <ModalMensajeComponent
          mostrar={this.state.Modal.Mostrar}
          handleCerrar={this.handleMostrarModal}
        >
          <h5>{this.state.Modal.Mensaje}</h5>
        </ModalMensajeComponent>
        <div className="row border-bottom">
          <div className="col-12">
            <h3 className="text-primary font-weight-bold">
              Inicia sesión o !registrate¡
            </h3>
          </div>
        </div>
        <div className="row d-flex align-items-center mt-auto">
          <div className="col-12 col-md-6">
            <div className="row pt-4">
              <div className="col-12">
                <h3 className="text-secondary font-weight-bold">
                  Nuevos clientes o Usuarios registrados
                </h3>
                <h6 className="font-italic mt-4">
                  Si no tienes una cuenta con nosotros puedes ingresar
                  simplemente ingresando un correo electronico y una contraseña
                </h6>
                <Link to="/Registro">
                  <Button variant="primary" type="button">
                    Crear Cuenta
                  </Button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            {!this.state.MostrarRecuperar ? (
              <LoginComponent
                clickLogin={this.handleClickLogin}
                clickGoogle={this.handleClickGoogle}
                clickRecuperar={this.handleMostrarRecuperar}
              />
            ) : (
              <RecuperarComponent
                clickRecuperar={this.handleMostrarRecuperar}
                clickEnviar={this.handleRecuperarPass}
              />
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ loginReducer }) => {
  return { loginReducer };
};

const mapDispatchToProps = {
  ...loginActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
